<template>
  <div class="mt-2" style="position: relative">
    <m-question :link="$store.getters['config/link']('agreementQuestion') + '&siteId=' + $store.state.site.SiteId"></m-question>
    <div class="m-disabled-box" v-if="!enablePlaceOrder"></div>

    <b-form-checkbox class="item" v-model = "aggreAgreement" data-test="summary-term-agree">
      <span v-if="IsEmailCampaign" name="email">I understand that USADATA will deploy this campaign and that I will not receive any actual
        email addresses with this order.</span>
      <span v-if="!IsEmailCampaign" name="notemail">I agree to the terms and conditions of the
        <b-link tabindex="-1" href="javascript:void(0)" @click="showdatauseagreement">Data Use Agreement</b-link>
        <span id="asterisk_before" class="color_red">*</span>
        and acknowledge that orders with consumer phone numbers or sensitive elements may be put on hold. (*)
      <icon name="question-circle"
            title="help"
            style="color: #e04557; height:20px;width:36px; cursor: pointer "
            @click.native="showQuestion"/></span>
    </b-form-checkbox>

    <p class="m-error-text item-error" v-if = "showError && aggreAgreement === false">You must agree to the terms of the Data Use Agreement to place this order.
    </p>

    <b-form-checkbox class="item" v-model = "IsContactMe" v-if= "ShowIsContactMe">
      Contact me to discuss reaching these same prospects via email, display, and/or social media.
    </b-form-checkbox>
  </div>
</template>

<script>
  import MQuestion from '@/components/common/Mquestion'
  export default {
    components: {
      MQuestion
    },
    computed: {
      aggreAgreement: {
        get () {
          return this.$store.state.summary.aggreAgreement
        },
        set (val) {
          this.$store.commit('summary/saveAggreAgreement', val)
        }
      },
      IsContactMe: {
        get () {
          return this.$store.state.order.IsContactMe  // @TODO@Wilson  lack not sl360 logic
        },
        set (val) {
          this.$store.commit('order/saveKey', ['IsContactMe', val])
        }
      },
      ShowIsContactMe () {
        return (this.$store.state.order.ListType === 10 && Math.min(this.$store.state.order.TotalAvailableQty, this.$store.state.order.TotalDesiredQty) >= 10000)
      },
      IsEmailCampaign () {
        return this.$store.getters['order/IsEmailCampaign']
      },
      showError () {
        return this.$store.getters['summary/showError']
      },
      enablePlaceOrder () {
        return this.$store.getters['site/enablePlaceOrder']
      }
    },
    methods: {
      showdatauseagreement () {
        this.$root.$emit('bv::show::modal', 'datauseagreement')
      },
      showQuestion () {
        this.$root.$emit('bv::show::modal', 'question')
      }
    }
  }
</script>

<style scoped lang="scss">
.item {
  font-size: 13px;
}
.item-error {
  margin-left: 24px;
  margin-top: -8px;
}
</style>



// WEBPACK FOOTER //
// src/components/summary/MCheckTerms.vue